app.controller("ExamsManagerSpecialsController", [
    "$scope", "ExamsManagerService", "ExamsService", "ConfirmModal", "$state", "$uibModal", "Subject", "toastr",
    function ($scope, ExamsManagerService, ExamsService, ConfirmModal, $state, $uibModal, Subject, toastr) {

        $scope.chosenSubject = null;

        $scope.fetch = function () {
            ExamsManagerService.fetchSpecialSubjects().then(function (data) {
                $scope.specialSubjects = data;
                $scope.totalItems = data.length;
                console.log(data);
            });
        };

        $scope.fetch();

        $scope.add = function () {
            if (!$scope.chosenSubject || !$scope.chosenSubject._id)
                return;
            ExamsManagerService.addSpecialSubject({subjectId: $scope.chosenSubject._id}).then(function () {
                $scope.fetch();
                $scope.chosenSubject = null;
                toastr.success('', 'ჩანაწერი წარმატებით დაემატა');
            });
            console.log($scope.chosenSubject);
        };


        $scope.getSubjects = function (query) {
            if (query.length < 2) {
                return [];
            }
            return ExamsService.activationList({query: query}).then(function (data) {
                return data.docs.map(function (activation) {
                    return activation.subject;
                });
            });
        };

        $scope.edit = function (specialSubject) {
            $uibModal.open({
                controller: "ExamsManagerEditSpecialController",
                templateUrl: _pb + 'admin/exams/manager/exams-manager-edit-special.html',
                size: "md",
                resolve: {
                    params: function () {
                        return {specialSubject: specialSubject};
                    }
                }
            }).result
                .then(function (result) {
                    $scope.fetch();
                }, function () {
                    $scope.fetch();
                });
        };

        $scope.remove = function (specialSubject) {
            console.log(specialSubject);
            ConfirmModal.show({
                title: "საგნის წაშლა",
                message: "გსურთ საგნის სიიდან წაშლა?"
            }).result.then(function () {
                ExamsManagerService.removeSpecialSubject({
                    specialSubjectId: specialSubject._id
                }).then(function (result) {
                    toastr.success('', 'ჩანაწერი წარმატებით წაიშალა სიიდან');
                    $scope.fetch();
                });
            });
        };

    }
]);
